import {
  getCheckoutSettings as publicGetCheckoutSettings,
  updateCheckoutSettings as publicUpdateCheckoutSettings,
} from './ecom-v1-checkout-settings-checkout-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { onCheckoutSettingsUpdated as publicOnCheckoutSettingsUpdated } from './ecom-v1-checkout-settings-checkout-settings.public.js';

export const getCheckoutSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetCheckoutSettings> &
    typeof publicGetCheckoutSettings
> = /*#__PURE__*/ createRESTModule(publicGetCheckoutSettings);
export const updateCheckoutSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCheckoutSettings> &
    typeof publicUpdateCheckoutSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateCheckoutSettings);
/**
 * Triggered when checkout settings are updated.
 */
export const onCheckoutSettingsUpdated: ReturnType<
  typeof createEventModule<typeof publicOnCheckoutSettingsUpdated>
> = createEventModule(publicOnCheckoutSettingsUpdated);

export {
  LogoSize,
  Alignment,
  WebhookIdentityType,
} from './ecom-v1-checkout-settings-checkout-settings.universal.js';
export {
  CheckoutSettings,
  CheckoutPolicies,
  TermsAndConditionsPolicy,
  PrivacyPolicy,
  ReturnPolicy,
  DigitalItemPolicy,
  ContactUsPolicy,
  CustomCheckoutPolicy,
  CheckoutFields,
  CheckboxField,
  CheckoutBrand,
  CheckoutHeader,
  Logo,
  FocalPoint,
  GetCheckoutSettingsRequest,
  GetCheckoutSettingsResponse,
  UpdateCheckoutSettingsRequest,
  UpdateCheckoutSettingsResponse,
  ListCheckoutSettingsRequest,
  ListCheckoutSettingsResponse,
  GiftCardProviderWasProvisioned,
  Empty,
  DeleteCheckoutSettingsRequest,
  DeleteCheckoutSettingsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  GetCheckoutSettingsResponseNonNullableFields,
  UpdateCheckoutSettingsResponseNonNullableFields,
  BaseEventMetadata,
  EventMetadata,
  CheckoutSettingsUpdatedEnvelope,
} from './ecom-v1-checkout-settings-checkout-settings.universal.js';
